<div class="card card-box mb-5">
    <div class="card-header bg-white">
        <div class="card-header--title">
            <small class="d-block text-uppercase mt-1">Blogs</small>
            <b>Latest articles</b>
        </div>
        <div class="card-header--actions">
            <a [routerLink]="" class="btn btn-sm btn-primary">Reports</a>
        </div>
    </div>
    <ul class="list-group list-group-flush">
        <li class="list-group-item py-4">
            <div class="d-flex flex-column flex-sm-row align-items-start">
                <div>
                    <div class="card card-transparent mb-3 mb-sm-0">
                        <a [routerLink]="" class="card-img-wrapper rounded">
                            <div class="img-wrapper-overlay">
                                <div class="overlay-btn-wrapper">
                                    <button class="btn btn-pill btn-sm btn-outline-secondary border-0 shadow-none pl-2 pr-2 mx-auto d-flex align-items-center"
                                            type="button">
                                        <fa-icon [icon]="['fas', 'plus-circle']" class="font-size-lg"></fa-icon>
                                    </button>
                                </div>
                            </div>
                            <img alt="..." class="card-img-top rounded"
                                 src="assets/images/stock-photos/stock-3.jpg" style="width: 160px">
                        </a>
                    </div>
                </div>
                <div class="pl-0 pl-sm-4">
                    <div class="mb-1">
                        <a [routerLink]="" class="font-size-lg">Meeting minutes</a>
                    </div>
                    <div>
                        <span class="badge badge-neutral-info text-info">Articles</span>
                        <span class="badge badge-neutral-danger text-danger ml-2">Posts</span>
                    </div>
                    <p class="mb-0 mt-2 text-black-50">
                        A wonderful serenity has taken possession of my entire soul, like these sweet mornings
                        ...
                    </p>
                </div>
            </div>
        </li>
        <li class="list-group-item py-4">
            <div class="d-flex flex-column flex-sm-row align-items-start">
                <div>
                    <div class="card card-transparent mb-3 mb-sm-0">
                        <a [routerLink]="" class="card-img-wrapper rounded">
                            <div class="img-wrapper-overlay">
                                <div class="overlay-btn-wrapper">
                                    <button class="btn btn-pill btn-sm btn-outline-secondary border-0 shadow-none pl-2 pr-2 mx-auto d-flex align-items-center"
                                            type="button">
                                        <fa-icon [icon]="['fas', 'plus-circle']" class="font-size-lg"></fa-icon>
                                    </button>
                                </div>
                            </div>
                            <img alt="..." class="card-img-top rounded"
                                 src="assets/images/stock-photos/stock-2.jpg" style="width: 160px">
                        </a>
                    </div>
                </div>
                <div class="pl-0 pl-sm-4">
                    <div class="mb-1">
                        <a [routerLink]="" class="font-size-lg">Sales reports for this week</a>
                    </div>
                    <div>
                        <a [routerLink]="" class="badge badge-neutral-success text-success">Blog</a>
                    </div>
                    <p class="mt-2 text-black-50">
                        Who formed us in his own image, and the breath ...
                    </p>
                </div>
            </div>
        </li>
        <li class="list-group-item bg-secondary text-center p-4">
            <button class="btn btn-facebook" tooltip="Facebook" type="button">
                            <span class="btn-wrapper--icon">
                                <fa-icon [icon]="['fab', 'facebook']" class="font-size-lg"></fa-icon>
                            </span>
            </button>
            <button class="btn btn-dribbble mr-2 ml-2" tooltip="Dribbble" type="button">
                            <span class="btn-wrapper--icon">
                                <fa-icon [icon]="['fab', 'dribbble']" class="font-size-lg"></fa-icon>
                            </span>
            </button>
            <button class="btn btn-twitter" tooltip="Twitter" type="button">
                            <span class="btn-wrapper--icon">
                                <fa-icon [icon]="['fab', 'twitter']" class="font-size-lg"></fa-icon>
                            </span>
            </button>
        </li>
    </ul>
</div>
